import VBtn from "./VBtn.vue";

export default VBtn;
